export const getLocalizationChoiceId = `query ParameterLocalizationChoice($filter: ParameterLocalizationChoiceRequest!) {
  parameterLocalizationChoice(filter: $filter) {
    localizationChoiceParameter {
      pkId
      version
      region
      productFamily
      productGroup
      parameterKey
      parameterValue
      parameterText
      comments
      status
      createdBy
      whoChanged
      lastModifiedDate
    }
  }
}`;